<template>
  <div class="account-page">
    <AccountWrapper />
  </div>
</template>

<script>
import AccountWrapper from '@/wrappers/AccountWrapper.vue';

export default {
  name: 'AccountPage',
  components: {
    AccountWrapper,
  },
  data() {
    return {
      // Define your component data here
    };
  },
  methods: {
    // Add your methods here
  },
  mounted() {
    // Lifecycle hook for when the component is mounted
  }
};
</script>

<style scoped>
.account-view {
    /* Add your styles here */
}
</style>